import React from 'react';

const CrossIcon = (props: object) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.210801 6.90288L3.11429 3.99911L0.219599 1.09533C0.101963 0.979711 0.0381746 0.82018 0.0436296 0.655368C0.0650098 0.324426 0.328612 0.0607987 0.659522 0.0394163C0.818422 0.0378324 0.971075 0.101451 1.08185 0.215403L4.00294 3.12798L6.92402 0.215402C7.0348 0.101451 7.18745 0.0378321 7.34635 0.039416C7.67726 0.0607983 7.94086 0.324426 7.96224 0.655368C7.9677 0.820179 7.90391 0.97971 7.78627 1.09533L4.89158 3.99911L7.78627 6.89408C7.90391 7.00971 7.9677 7.16924 7.96224 7.33405C7.94465 7.6715 7.67497 7.9412 7.33755 7.9588C7.17865 7.96038 7.026 7.89677 6.91523 7.78281L4.00294 4.87024L1.08185 7.79161C0.96958 7.9024 0.81719 7.96276 0.659522 7.9588C0.328612 7.93742 0.0650102 7.67379 0.0436299 7.34285C0.0358873 7.17936 0.0964207 7.02 0.210801 6.90288Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CrossIcon;
